import { ITokenResponse } from '../models/AndromeTV.types';

export class TokenInfo {
  readonly token: string;
  readonly expires: number;

  constructor(token: string, millis: number) {
    this.token = token;
    this.expires = millis;
  }

  isValid() {
    const now = new Date().getTime();
    return this.token && this.expires > now;
  }
}

export class TokenData {
  public access?: TokenInfo;
  public refresh?: TokenInfo;

  constructor(tokenResponse?: ITokenResponse) {
    if (tokenResponse) {
      const millisSinceEpoch = new Date().getTime();
      if (tokenResponse.access_token && tokenResponse.expires_in)
        // todo ts-check, leave undefined if these are missing?
        this.access = new TokenInfo(tokenResponse.access_token, millisSinceEpoch + tokenResponse.expires_in * 1000);
      if (tokenResponse.refresh_token && tokenResponse.refresh_token_expires_in)
        this.refresh = new TokenInfo(
          tokenResponse.refresh_token,
          millisSinceEpoch + tokenResponse.refresh_token_expires_in * 1000
        );
    }
  }
}
